// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DoubleLeftOutlinedSvg from "@fishx/icons-svg/es/asn/DoubleLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DoubleLeftOutlinedSvg
  }));
};

DoubleLeftOutlined.displayName = 'DoubleLeftOutlined';
export default React.forwardRef(DoubleLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DoubleLeftOutlined.js
// module id = 2445
// module chunks = 0